/**
 * Single source of truth for the custom flags we tack onto Cornerstone
 * annotation objects. Keeping the names here prevents typo drift across
 * the half-dozen modules that filter or mutate them.
 *
 * - `_loadedFromMask`: set true by niftiMaskLoader when reconstructing
 *   contours from a saved NIfTI. The renderer (purple style), the delete
 *   hotkeys, and the save payload all key off this flag to distinguish
 *   "saved, locked" contours from "actively drawing" contours.
 */
export const LOADED_FROM_MASK_KEY = "_loadedFromMask" as const;

type MaybeMaskAnn = { _loadedFromMask?: boolean } | null | undefined;

export function isLoadedFromMask(ann: unknown): boolean {
  return !!(ann as MaybeMaskAnn)?._loadedFromMask;
}

export function setLoadedFromMask(ann: { _loadedFromMask?: boolean }, value: boolean): void {
  ann._loadedFromMask = value;
}
